import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { SiteLayout } from "./components/SiteLayout";
import { Home } from "./pages/Home";
import { ComingSoon } from "./pages/ComingSoon";
export function App() {
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3farhvzdwq88b">
      <BrowserRouter data-id="element-1" data-mp="3fb16bijb07bw">
        <Routes data-id="element-2" data-mp="3f8exzgol9nsm">
          <Route element={<SiteLayout data-id="element-4" data-mp="2rknlabz4z8qt" />} data-id="element-3" data-mp="2rkx3hddxwbly">
            <Route path="/" element={<Home data-id="element-6" data-mp="2rl6vt7mgiuut" />} data-id="element-5" data-mp="2rlyoa9krccgv" />
            <Route path="*" element={<ComingSoon data-id="element-8" data-mp="2mmcds7wbdabr" />} data-id="element-7" data-mp="2rikqzfqyatga" />
          </Route>
        </Routes>
      </BrowserRouter>
    </MotionConfig>;
}